import * as React from "react";
import memoize from "utils/memoize";
const StytchTickIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path stroke="#000" strokeLinecap="round" d="M4 8.367 6.409 11 12 5" />
  </svg>
);
export default memoize(StytchTickIcon);
